import { reservationActions as ReservationActions, resourceActions as ResourceActions } from '@bottega52/bookey-redux-module';
import { withStyles } from '@material-ui/core';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { change, initialize, submit } from 'redux-form';
import { GREEN } from '../../_config/consts.js';
import * as formatter from '../../_config/formatter';

import CalendarEditIconCustom from '../../components/CustomIcons/CalendarEditIconCustom.jsx';
import MDButton from '../../components/MDButton/MDButton.jsx';
import ReservationForm from '../../components/forms/Bookey/ReservationForm.jsx';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UserActions from '../../redux/actions/user.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';

// Default Bookey hourly window: next 15-min slot, duration = min reservation (60 if unknown)
const DEFAULT_MIN_RESERVATION_MINUTES = 60;
const SLOT_MINUTES = 15;

function getDefaultHourlyReservationTimes(minDurationMinutes = DEFAULT_MIN_RESERVATION_MINUTES) {
  const slotMs = SLOT_MINUTES * 60 * 1000;
  const start = moment(Math.ceil(Date.now() / slotMs) * slotMs);
  const end = start.clone().add(minDurationMinutes, 'minutes');
  return {
    dateFrom: start.valueOf(),
    dateTo: start.valueOf(),
    startTime: start.valueOf(),
    endTime: end.valueOf(),
  };
}

const styles = theme => ({
  // ponytail: body/#app-container lock overflow on tablet; fixed scrollport like ResetPasswordOnboardingInstaller
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
  },
  appBar: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: '#157495',
    color: 'white',
    padding: '16px 24px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media (max-width: 768px)': {
      padding: '12px 16px',
    },
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  logo: {
    height: 40,
    '@media (max-width: 768px)': {
      height: 32,
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    '@media (max-width: 768px)': {
      fontSize: 18,
    },
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
  },
  userName: {
    fontSize: 14,
    fontWeight: 500,
    margin: 0,
    '@media (max-width: 768px)': {
      fontSize: 12,
    },
  },
  logoutButton: {
    fontSize: 12,
    color: 'white',
    textDecoration: 'underline',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
  },
  container: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'center',
    padding: 40,
    '@media (max-width: 768px)': {
      padding: 16,
    },
  },
  formCard: {
    width: '100%',
    height: 'auto',
    minHeight: 'fit-content',
    backgroundColor: 'white',
    paddingBottom: 100,
    borderRadius: 12,
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    padding: 40,
    '@media (max-width: 768px)': {
      padding: 24,
      borderRadius: 8,
      marginBottom: 200,
    },
  },
  formHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginBottom: 22,
    borderBottom: '2px solid #f0f0f0',
  },
  formIcon: {
    width: 40,
    height: 40,
    color: '#157495',
  },
  formTitle: {
    fontSize: 28,
    fontWeight: 600,
    color: '#333',
    margin: 0,
    '@media (max-width: 768px)': {
      fontSize: 22,
    },
  },
  formSubtitle: {
    fontSize: 16,
    color: '#666',
    marginTop: 4,
    '@media (max-width: 768px)': {
      fontSize: 14,
    },
  },
  submitButton: {
    marginTop: 32,
    width: '100%',
  },
});

class ReservationSuccessModalContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countdownSeconds: 60,
    };
    this.countdownInterval = null;
  }

  componentDidMount() {
    this.countdownInterval = setInterval(() => {
      this.setState(prevState => {
        const newSeconds = prevState.countdownSeconds - 1;
        if (newSeconds <= 0) {
          clearInterval(this.countdownInterval);
          this.props.onEndSession();
          return { countdownSeconds: 0 };
        }
        return { countdownSeconds: newSeconds };
      });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  render() {
    const { onCreateNew, onEndSession } = this.props;
    const { countdownSeconds } = this.state;

    return (
      <div style={{ marginTop: 30, display: 'flex', flexDirection: 'column', gap: 20 }}>
        <h4 style={{ color: '#3f3f3f', marginBottom: 0, textAlign: 'center' }}>
          <Entity entity="whatWouldYouLikeToDo" />
        </h4>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 10, justifyContent: 'center' }}>
        <MDButton
          backgroundColor={GREEN}
          title={<Entity entity="createNewReservation" />}
          onClick={onCreateNew}
          containerStyle={{ width: '100%' }}
        />
        <MDButton
          backgroundColor="#ff5252"
          title={
            <span>
              <Entity entity="endSession" /> ({countdownSeconds}s)
            </span>
          }
          onClick={onEndSession}
          containerStyle={{ width: '100%' }}
        />
        </div>
      </div>
    );
  }
}

@withRouter
@connect(state => ({
  user: state.user,
  viewLoading: state.utils.viewLoading,
  availableResources: state.resources.availableResources, 
}))
class BookeyReserve extends React.Component {
  
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const defaults = getDefaultHourlyReservationTimes();
    const formatted = formatter.formatOutputData(formatter.RESERVATION_DATES, defaults);
    // Initialize before/with fetch so TimePicker sees values on first paint after refresh
    dispatch(initialize('ReservationForm', {
      dateFrom: formatted.dateFrom,
      dateTo: formatted.dateTo,
      timeFrom: formatted.dateFrom,
      timeTo: formatted.dateTo,
    }));
    await this.fetchAvailableResourcesForReservation(0, 200, defaults);
  }


  async fetchAvailableResourcesForReservation(page = 0, pageSize = 200, availableResourcesData, append = false) {
    const { dispatch, user, } = this.props;
    const userId = user.data.id;
    const formattedDates = formatter.formatOutputData(formatter.RESERVATION_DATES, availableResourcesData);
    const dateFrom = formattedDates.dateFrom;
    const dateTo = formattedDates.dateTo;
    const filters = {
      fromDate: dateFrom,
      toDate: dateTo,
      userId: userId,
      numberOfPeople: availableResourcesData.numberOfPeople || 1,
      pageSize: 200
    };
    dispatch(change('ReservationForm', 'dateFrom', dateFrom));
    dispatch(change('ReservationForm', 'dateTo', dateTo));
    dispatch(change('ReservationForm', 'timeFrom', dateFrom));
    await dispatch(ResourceActions.fetchAvailableResourcesWithMedia(page, pageSize, filters, append));
    dispatch(change('ReservationForm', 'timeTo', dateTo));
  }

  async onFetchMoreAvailableResources(page, pageSize, availableResourcesData, append) {
    const { dispatch } = this.props;
    try {
      await dispatch(ResourceActions.fetchAvailableResources(page, pageSize, availableResourcesData, append));
    } catch (error) {
      console.error('Error fetching more resources:', error);
      return [];
    }
  }

  async onSubmitReservation(reservationData) {
    const { dispatch, user } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const parsedValues = {
        dateFrom: moment(reservationData.timeFrom).valueOf(),
        dateTo: moment(reservationData.timeTo).valueOf(),
        checkInNotNecessary: reservationData.checkInNotNecessary,
        resourceId: reservationData.resourceId,
        title: reservationData.title,
        description: reservationData.description,
        numberOfPeople: parseInt(reservationData.numberOfGuests || 0, 10) + 1,
        invitedEmails: reservationData.invitedEmails ? reservationData.invitedEmails.filter(e=>e.guest && e.guest.email).map(e => e.guest.email) : [],
      }
      const formattedData = formatter.formatOutputData(formatter.RESERVATION, { ...parsedValues });
      await dispatch(ReservationActions.createReservation(formattedData));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.showReservationSuccessModal();
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (
            <h6 className="snack-title">
              <Entity entity="reservationCreationError" />
            </h6>
          ),
        },
      }));
    }
  }

  showReservationSuccessModal() {
    const { dispatch } = this.props;
    
    const params = {
      modalType: 'CONTENT_MODAL',
      modalProps: {
        title: <Entity entity="reservationCreatedSuccessfully" />,
        content: <ReservationSuccessModalContent 
          onCreateNew={() => this.onCreateNewReservation()}
          onEndSession={() => this.onEndSession()}
        />,
        hideButtons: true,
        modalStyle: { maxWidth: 500 },
        onOutsideClick: () => this.onCreateNewReservation(),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  onCreateNewReservation() {
    const { dispatch } = this.props;
    const defaults = getDefaultHourlyReservationTimes();
    const formatted = formatter.formatOutputData(formatter.RESERVATION_DATES, defaults);
    dispatch(ModalActions.hideModal());
    dispatch(initialize('ReservationForm', {
      dateFrom: formatted.dateFrom,
      dateTo: formatted.dateTo,
      timeFrom: formatted.dateFrom,
      timeTo: formatted.dateTo,
    }));
    this.fetchAvailableResourcesForReservation(0, 20, defaults);
  }

  onEndSession() {
    const { dispatch } = this.props;
    dispatch(ModalActions.hideModal());
    dispatch(UserActions.logoutFromBookey());
  }

  onLogout() {
    const { dispatch } = this.props;
    dispatch(UserActions.logout());
    dispatch(push('/bookey/login'));
  }

  render() {
    const { availableResources, classes, user } = this.props;
    const userFullName = `${user.data.firstname || ''} ${user.data.lastname || ''}`.trim();
    const availableResourcesFiltered = {
      ...availableResources,
      content: availableResources &&availableResources.content ? availableResources.content.filter(e=>e.capacity<=1):[]
    }
    return (
      <div className={classes.root}>
        <div className={classes.appBar}>
          <div className={classes.headerLeft}>
            <img 
              src="/imgs/common/logoJagoWhite.png" 
              alt="Jago Logo" 
              className={classes.logo}
            />
            <h1 className={classes.title}>
              <Entity entity="makeReservation" />
            </h1>
          </div>
          <div className={classes.userInfo}>
            <p className={classes.userName}>
              {userFullName || user.data.email}
            </p>
            <button 
              className={classes.logoutButton}
              onClick={() => this.onLogout()}
            >
              <Entity entity="logout" />
            </button>
          </div>
        </div>

        <div className={classes.container}>
          <div className={classes.formCard}>
            <div className={classes.formHeader}>
              <CalendarEditIconCustom style={{ width: 24, height: 24 }} />
              <div>
                <h2 className={classes.formTitle}>
                  <Entity entity="newReservation" />
                </h2>
                <p className={classes.formSubtitle}>
                  <Entity entity="fillFormToCreateReservation" />
                </p>
              </div>
            </div>

            <ReservationForm
              onSubmit={reservationData => this.onSubmitReservation(reservationData)}
              dateHasBeenChanged={(dates, userTagId, resourceName, page) => {
                
                this.fetchAvailableResourcesForReservation(0, 20, { userId: user.data.id, dateFrom: dates.dateFrom, dateTo: dates.dateTo, startTime: dates.startTime, endTime: dates.endTime, numberOfPeople: 1, resourceName: resourceName }, false)
              }
              }
              onFetchMoreAvailableResources={(page, pageSize, data, append) =>
                this.onFetchMoreAvailableResources(page, pageSize, data, append)
              }
              availabileResources={availableResourcesFiltered}
              isGuestReservation={true}
              availableResourcesContainerStyle={{ marginBottom: 50 }}
            />

            <MDButton
              backgroundColor={GREEN}
              style={{ height: 50 }}
              containerStyle={{ margin:0, marginTop: 32, width: '100%' }}
              titleStyle={{ fontSize: 20}}
              title={<Entity entity="createReservation" />}
              onClick={() => {
                const { dispatch } = this.props;
                dispatch(submit('ReservationForm'));
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BookeyReserve);
